import { axiosInstance } from "../../utils/axios";
import { DEFAULT_FOLDER_CREATION } from "../../components/document/WithApiFileLocationProvider";
import { DocumentPart } from "../models";
import { EmbeddedRoots } from "../models/embedded-roots";

export function fetchDocumentList(path: string): Promise<DocumentPart[]> {
  let pathEncoded = normalizePath(path);
  return axiosInstance.get(`/documentpart/documentlist${pathEncoded}`).then((resp) => resp.data);
}

export function fetchDocumentRoots(name: string, page: string): Promise<EmbeddedRoots> {
  if (!name) {
    name = "";
  }
  const ITEMS_PER_PAGE = 20;
  return axiosInstance
    .get(`/documentpart/documentroots?name=${name}&page=${page}&size=${ITEMS_PER_PAGE}`)
    .then((resp) => resp.data);
}

export function fetchExploredDocumentPartLocation(path: string): Promise<DocumentPart[]> {
  let pathEncoded = normalizePath(path);
  return axiosInstance.get(`/folders${pathEncoded}`).then((resp) => resp.data);
}

export function fetchZipFileList(path: string): Promise<DocumentPart[]> {
  let pathEncoded = normalizePath(path);
  return axiosInstance.get(`/documentpart/zipandfolderlist${pathEncoded}`).then((resp) => resp.data);
}

function normalizePath(path: string) {
  let pathEncoded = path && path.length > 0 ? "?path=" + path : "";
  pathEncoded = pathEncoded.replace(DEFAULT_FOLDER_CREATION + ">", "").replace(/[<>]/g, "/");
  return pathEncoded;
}

export function fetchNonTagetikDocumentsList(path: string): Promise<DocumentPart[]> {
  let pathEncoded = normalizePath(path);
  return axiosInstance.get(`/documentpart/nontagetikdocumentlist${pathEncoded}`).then((resp) => resp.data);
}
